import {
    IndexTable,
    Text,
    // Badge,
    // useBreakpoints,
} from '@shopify/polaris';
import React from 'react';
import Language from '../../../../i18n/Language';
const t = Language;

const ImageAddOnesTable = (props) => {
    const {
        addoneList
    } = props;

    const resourceName = {
        singular: t("order"),
        plural: t("orders"),
    };

    const rowMarkup = addoneList.map(
        (
            {
                id, date, Product, price, gift
                // states
            },
            index,
        ) => (
            <IndexTable.Row id={id} key={id} position={index}>
                <IndexTable.Cell>
                    <Text variant="bodyMd" fontWeight="bold" as="span">{date}</Text>
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <Text variant="bodyMd" fontWeight="bold" as="span">
                        {Product}
                        {
                            gift > 0 ? ` + ` : ''
                        }
                        {
                            gift > 0 ? <>
                                <span>{`${gift}`}</span>&nbsp;
                                <span style={{ color: "#1dcf76" }}>{`(${t("gift")})`}</span>
                            </> : null
                        }
                    </Text>
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <Text variant="bodyMd" fontWeight="bold" as="span">${price}</Text>
                </IndexTable.Cell>
                {/* <IndexTable.Cell>
                    <Text variant="bodyMd" fontWeight="bold" as="span">{states}</Text>
                </IndexTable.Cell> */}
            </IndexTable.Row>
        ),
    );

    return (
        <IndexTable
            // condensed={useBreakpoints().smDown}
            resourceName={resourceName}
            itemCount={addoneList.length}
            headings={[
                { title: t("Date") },
                { title: t("Product") },
                { title: t("Amount") },
                // { title: t("Credit") },
            ]}
            selectable={false}
        >
            {rowMarkup}
        </IndexTable>
    );
}

export default ImageAddOnesTable;